import React from 'react';
import { Link } from 'gatsby';
import clsx from 'clsx';
import {
  IconTwitter,
  IconFacebook,
  IconPhone,
  IconMail,
  IconArrowRight,
} from '~/icons';
import * as styles from './SiteFooter.module.scss';

const SiteFooter = React.forwardRef((props, ref) => {
  const {
    className,
    isHomePage = false,
    ...other
  } = props;

  return (
    <footer
      ref={ref}
      className={clsx(styles.wrapper, className)}
      data-is-root-path={isHomePage}
      {...other}
    >
      <div className={styles.bar}>
        {!isHomePage && (
          <p className={styles.message}>Webアプリケーション、スマートフォンアプリの企画・開発・運用、<br />
            業務システムの企画・開発、UI・UX改善について、お気軽にお問い合わせください。</p>
        )}
        <div className={styles.icons}>
          <a
            href="tel:0242-23-8285"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.button}
            aria-label="会津ラボに電話をかける"
          >
            <IconPhone />
          </a>
          <a
            href="m&#97;i&#108;t&#111;:&#105;&#110;&#102;&#111;&#64;&#97;&#105;&#122;&#117;l&#97;b&#46;co&#109;"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.button}
            aria-label="会津ラボにEメールを送る"
          >
            <IconMail />
          </a>
          <a
            href="https://www.facebook.com/aizulab"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.button}
            aria-label="会津ラボのFacebookページへ"
          >
            <IconFacebook />
          </a>
          <a
            href="https://twitter.com/aizulab"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.button}
            aria-label="会津ラボのTwitterページへ"
          >
            <IconTwitter />
          </a>
        </div>
      </div>
      <div className={styles.row}>
        <ul className={styles.nav}>
          <li className={styles.navItem}>
            <Link to="/" className={styles.navLink}>
              <span className={styles.navText} data-ruby="top">概要</span>
              <IconArrowRight className={styles.navIcon} />
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link to="/blog/" className={styles.navLink}>
              <span className={styles.navText} data-ruby="blog">ブログ</span>
              <IconArrowRight className={styles.navIcon} />
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link to="/news" className={styles.navLink}>
              <span className={styles.navText} data-ruby="news">お知らせ</span>
              <IconArrowRight className={styles.navIcon} />
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link to="/contact" className={styles.navLink}>
              <span className={styles.navText} data-ruby="contact us">お問い合わせ</span>
              <IconArrowRight className={styles.navIcon} />
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link to="/cases" className={styles.navLink}>
              <span className={styles.navText} data-ruby="case study">開発事例</span>
              <IconArrowRight className={styles.navIcon} />
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link to="/privacy" className={styles.navLink}>
              <span className={styles.navText} data-ruby="privacy policy">個人情報保護方針</span>
              <IconArrowRight className={styles.navIcon} />
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link to="/company" className={styles.navLink}>
              <span className={styles.navText} data-ruby="company">会社情報</span>
              <IconArrowRight className={styles.navIcon} />
            </Link>
          </li>
        </ul>
        <nav className={styles.archives}>
          <h1 className={styles.archivesTitle}>記事カテゴリー</h1>
          <ul className={styles.list}>
            <li className={styles.listItem} data-ruby="-">
              <Link to="/blog/category/technology/" className={styles.listLink}>テクノロジー</Link>
            </li>
            <li className={styles.listItem} data-ruby="-">
              <Link to="/blog/category/app/" className={styles.listLink}>アプリ</Link>
            </li>
            <li className={styles.listItem} data-ruby="-">
              <Link to="/blog/category/web/" className={styles.listLink}>Web制作</Link>
            </li>
            <li className={styles.listItem} data-ruby="-">
              <Link to="/blog/category/design/" className={styles.listLink}>デザイン</Link>
            </li>
            <li className={styles.listItem} data-ruby="-">
              <Link to="/blog/category/life/" className={styles.listLink}>ライフ</Link>
            </li>
            <li className={styles.listItem} data-ruby="-">
              <Link to="/blog/category/info/" className={styles.listLink}>お知らせ/募集</Link>
            </li>
          </ul>
        </nav>
        <nav className={styles.archives}>
          <h1 className={styles.archivesTitle}>人気記事タイトル</h1>
          <ul className={styles.list}>
            <li className={styles.listItem} data-ruby="□">
              <Link to="/blog/minecraft-server/" className={styles.listLink}>Minecraft(統合版)を自宅サーバーで遊んでみた！Ubuntuによる構築に挑戦</Link>
            </li>
            <li className={styles.listItem} data-ruby="□">
              <Link to="/blog/minecraftserver-conohavps/" className={styles.listLink}>マイクラのマルチサーバー構築を諦めたひとは必見!サーバーにConoHa VPSを選んで分かったこと</Link>
            </li>
            <li className={styles.listItem} data-ruby="□">
              <Link to="/blog/css-flexbox-liquid-layout/" className={styles.listLink}>flexboxでリキッドレイアウト（固定＋可変）にする方法</Link>
            </li>
            <li className={styles.listItem} data-ruby="□">
              <Link to="/blog/free-contact-form-service/" className={styles.listLink}>【無料】PHP無し、HTMLだけ！お問い合わせフォームの作り方</Link>
            </li>
            <li className={styles.listItem} data-ruby="□">
              <Link to="/blog/react-hooks-onchange-eventhandler/" className={styles.listLink}>React Hooksに対応した複数のonChangeハンドラを処理する書き方</Link>
            </li>
            <li className={styles.listItem} data-ruby="□">
              <Link to="/blog/android-firebase-fcm/" className={styles.listLink}>AndroidでFirebaseを使ったPush通知(FCM)を実装する</Link>
            </li>
            <li className={styles.listItem} data-ruby="□">
              <Link to="/blog/mildom-chrome-extensions/" className={styles.listLink}>Mildom（ミルダム）のコメント欄を非表示にする方法ある？表示切り替えるChrome拡張機能をつくる</Link>
            </li>
          </ul>
        </nav>
      </div>
      <p className={styles.copyright}>Copyright Aizu Laboratory, Inc.</p>
    </footer>
  );
});

export default React.memo(SiteFooter);
